export default "__VITE_ASSET__DE74sHYb__"